import { RidangoReduxAction } from '@ridango/core';

import { RouteSearchEntity } from '../../schedule.model';
import { RouteSearchActions } from './route-search.action';

const PREVIOUS_SEARCH_SIZE = 3;

export const ROUTE_SEARCH_STATE_KEY = 'routeSearch';

export interface RouteSearchState {
    ids: string[];
    entities: RouteSearchEntity;
    previousSearch: any[];
}

export const ROUTE_SEARCH_INITIAL_STATE: RouteSearchState = {
    ids: [],
    entities: {},
    previousSearch: []
};

export function routeSearchReducer(
    state: RouteSearchState = ROUTE_SEARCH_INITIAL_STATE,
    action: RidangoReduxAction
): RouteSearchState {
    switch (action.type) {
        case RouteSearchActions.SET_ROUTE_SEARCH_DATA:
            return {
                ...state,
                ids: Object.keys(action.payload),
                entities: action.payload,
            };
        case RouteSearchActions.SET_PREVIOUS_SEARCH:
            const previousSearch = state.previousSearch;
            const routeId = action.payload;

            if (!previousSearch.includes(routeId)) {
                if (previousSearch.length === PREVIOUS_SEARCH_SIZE) {
                    previousSearch.pop();
                }

                previousSearch.unshift(action.payload);
            }

            return {
                ...state,
                previousSearch: previousSearch,
            };
    }

    return state;
}
